import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { BHRTHero } from '../components/bhrt/BHRTHero';
export function BHRTPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2435">
      <Navigation data-id="element-2436" />
      <main data-id="element-2437">
        <BHRTHero data-id="element-2438" />
      </main>
      <Footer data-id="element-2439" />
    </div>;
}